define(
    'viewmodels/secured/libraries/delete',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings",
        "viewmodels/secured/explorer/navigation/libraries/libraries"
    ],
    function (ViewModel, dataProvider, i19n, explorerLibraries) {

        var vm = new ViewModel(
        {
            id: '',
            name: '',
            notify: {},
            reload: {},
            comboClick: {},
            i19n: i19n,
            isErrorVisible: ko.observable(false)
        });

        vm.activate = function () {
            vm.isErrorVisible(false);
        };
        vm.attached = function () {
        };
        vm.deleteClick = function () {
            dataProvider
            .libraries
            .deleteLibrary(vm.id)
            .done(function (result) {
                sessionStorage.setItem("view-library-id", null);

                vm.notify('success', i19n.to.librarydeleted);
                    
                //vm.comboClick();
                //vm.reload();

                //vm.isErrorVisible(false);

                //explorerLibraries.loadLibraries();

                location.reload();
            })
            .fail(function (e) {
                e.stopPropagation = true;

                vm.notify(e.error);
                vm.isErrorVisible(true);

                console.error(e);
            });

        };
        vm.cancelClick = function () {
            vm.comboClick(vm.id);
        };
        vm.okClick = function () {
            vm.comboClick(vm.id);
        };

        return vm;
    }
);
